

<div style="background-image: url('../../../assets/images/solo_loader.gif');">
</div>